/**
 * deviceFingerprint — fingerprint stabile del browser/device.
 *
 * Usa una combinazione di:
 *   - User-Agent
 *   - Lingua
 *   - Timezone
 *   - Risoluzione schermo
 *   - Canvas hash (pixel resa di un canvas piccolo)
 *
 * Restituisce una stringa hex di ~16 caratteri stabile per il device.
 * NON è univoca al 100% (può collidere con altri device identici), ma
 * sufficiente per anti-frode "casual" tipo bonus referral.
 *
 * iter v29 r227 — Aggiunto per claim bonus Instagram (1 claim per device).
 */
export async function deviceFingerprint() {
  try {
    const parts = [
      navigator.userAgent || "",
      navigator.language || "",
      Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      `${screen.width}x${screen.height}`,
      `${screen.colorDepth}`,
      navigator.platform || "",
      navigator.hardwareConcurrency || "",
    ];

    // Canvas fingerprint — micro-differenze nella resa rivelano GPU/driver
    try {
      const c = document.createElement("canvas");
      c.width = 200;
      c.height = 40;
      const ctx = c.getContext("2d");
      if (ctx) {
        ctx.textBaseline = "top";
        ctx.font = '14px "Arial"';
        ctx.fillStyle = "#f60";
        ctx.fillRect(125, 1, 62, 20);
        ctx.fillStyle = "#069";
        ctx.fillText("Pronto-fp", 2, 15);
        ctx.fillStyle = "rgba(102, 204, 0, 0.7)";
        ctx.fillText("Pronto-fp", 4, 17);
        parts.push(c.toDataURL().slice(-100));
      }
    } catch { /* canvas may be blocked in incognito */ }

    const raw = parts.join("|");
    // SHA-256 → primi 16 char hex
    if (window.crypto?.subtle) {
      const buf = new TextEncoder().encode(raw);
      const hash = await window.crypto.subtle.digest("SHA-256", buf);
      return Array.from(new Uint8Array(hash))
        .slice(0, 8)
        .map((b) => b.toString(16).padStart(2, "0"))
        .join("");
    }
    // Fallback: hash semplice
    let h = 0;
    for (let i = 0; i < raw.length; i++) {
      h = (h << 5) - h + raw.charCodeAt(i);
      h |= 0;
    }
    return `fp${Math.abs(h).toString(16)}`;
  } catch {
    return `fp-${Date.now().toString(36)}`;
  }
}
